import Application from ".";
import { useParams } from "react-router-dom";

const JobPostApplication = () => {
  const { jobAdId } = useParams();
  return <Application rootPage={`/jobs/${jobAdId}`} />;
};

export default JobPostApplication;
